import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllAgents } from "../../api/apiAgents";
import parseError from "../../utils/parseError";

const useForceDeleteAllAgents = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllAgentsAction, isPending } = useMutation({
        mutationFn: forceDeleteAllAgents,
        onSuccess: (res) => {
            const message = res?.message || "Agents permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["agents"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete agents");
        },
    });

    return { forceDeleteAllAgents: forceDeleteAllAgentsAction, isPending };
};

export default useForceDeleteAllAgents;
